import React from "react";
import { connect } from "react-redux";
import { StockTransferJson } from "../../../DynamicFormsJson/Transaction/stockTransfer";
import { getStockholderByAreaIdsForFilter } from "../../../Slice/StackHolder.slice";
import {
  getAreaByTalukaPostBody,
  getAreaByUserType,
} from "../../../Slice/area.slice";
import { setDayWiseBitAssign } from "../../../Slice/dayWiseBitAssign.slice";
import { getDistrictByZone } from "../../../Slice/district.slice";
import { getRegionNew } from "../../../Slice/region.slice";
import { getDriversByStockHolderId } from "../../../Slice/salesExecutive.slice";
import { getStateByRegion } from "../../../Slice/state.slice";
import {
  getStockTransferInOutHeader,
  getStockTransferInOutHeaderByDriver,
} from "../../../Slice/stockTransfer.slice";
import { getTalukaByDistrict } from "../../../Slice/taluka.slice";
import {
  getUpdatedDayWiseBeatOutletCountFromAreas,
  getVehicleAssignDayWise,
} from "../../../Slice/vehicleAssign.slice";
import { getZoneByState } from "../../../Slice/zone.slice";
import DynamicMainScreen from "../../../components/dynamicscreens/DynamicMainScreen";
import endpoint from "../../../config/endpoints";
import {
  approveClaimMsg,
  noInternetMsg,
  rejectClaimMsg,
  serverMsg,
  statusmsg,
} from "../../../config/messageconstant";
import { StockTransferColumns } from "../../../tableColumns/table-columns";
import { apiGet } from "../../../utils/api_service";
import { showLoador, showNotification } from "../../Landing/Landing.slice";
class StockTransferTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dynamicMasterData: {
        regionDetail: this.props.regionList?.region,
        stateDetail: this.props.stateList?.stateByRegion,
        zoneDetail: this.props.zoneList?.zoneByState,
        districtDetail: this.props.districtList?.districtByZone,
        talukaDetail: this.props.talukaList?.talukaByDistrict,
        areaDetail: this.props.areaList?.areaByTaluka,
        areaByUserDetail: this.props.areaList?.area,
        stockHolderDetail: this.props.stockHolderList?.stockholderByArea,
        driverDetail: this.props.driverList?.driverByStockHolder,
      },
      adminFlag: false,
      areaIds: {},
      status: "0",
    };
  }
  async componentDidMount() {
    const {
      getRegionNew,
      setDayWiseBitAssign,
      getAreaByUserType,
      getVehicleAssignDayWise,
      getStockTransferInOutHeader,
      showLoador,
      showNotification,
    } = this.props;
    const userTypeId = localStorage.getItem("userTypeId");

    if (navigator.onLine) {
      setDayWiseBitAssign({ row: [] });

      if (userTypeId == 1 || userTypeId == 6) {
        showLoador({ loador: true });
        await getRegionNew().then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          } else {
            this.setState({
              adminFlag: true,
            });
          }
        });
      } else {
        showLoador({ loador: true });
        await getAreaByUserType().then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });

        this.getOnLoadData();
      }
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  }

  getOnLoadData = () => {
    const { getStockTransferInOutHeader, showLoador, showNotification } =
      this.props;
    showLoador({ loador: true });
    getStockTransferInOutHeader({
      stockStakeHolderId: "",
      fromDate: "",
      toDate: "",
    }).then(({ success, response }) => {
      showLoador({ loador: false });
      if (!success) {
        showNotification({ msg: serverMsg, severity: "error" });
      }
    });
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.regionList !== nextProps.regionList) {
      if (this.props.regionList?.region !== nextProps.regionList?.region) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            regionDetail: nextProps.regionList?.region,
          },
        });
      }
    }
    if (this.props.stateList !== nextProps.stateList) {
      if (
        this.props.stateList?.stateByRegion !==
        nextProps.stateList?.stateByRegion
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            stateDetail: nextProps.stateList?.stateByRegion,
          },
        });
      }
    }
    if (this.props.zoneList !== nextProps.zoneList) {
      if (
        this.props.zoneList?.zoneByState !== nextProps.zoneList?.zoneByState
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            zoneDetail: nextProps.zoneList?.zoneByState,
          },
        });
      }
    }
    if (this.props.districtList !== nextProps.districtList) {
      if (
        this.props.districtList?.districtByZone !==
        nextProps.districtList?.districtByZone
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            districtDetail: nextProps.districtList?.districtByZone,
          },
        });
      }
    }
    if (this.props.talukaList !== nextProps.talukaList) {
      if (
        this.props.talukaList?.talukaByDistrict !==
        nextProps.talukaList?.talukaByDistrict
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            talukaDetail: nextProps.talukaList?.talukaByDistrict,
          },
        });
      }
    }
    if (this.props.areaList !== nextProps.areaList) {
      if (this.props.areaList?.area !== nextProps.areaList?.area) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            areaDetail: nextProps.areaList?.area,
          },
        });
      }
    }

    if (this.props.areaList !== nextProps.areaList) {
      if (
        this.props.areaList?.areaByTaluka !== nextProps.areaList?.areaByTaluka
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            areaDetail: nextProps.areaList?.areaByTaluka,
          },
        });
      }
    }
    if (this.props.stockHolderList !== nextProps.stockHolderList) {
      if (
        this.props.stockHolderList?.stockholderByArea !==
        nextProps.stockHolderList?.stockholderByArea
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            stockHolderDetail: nextProps.stockHolderList?.stockholderByArea,
          },
        });
      }
    }
    if (this.props.driverList !== nextProps.driverList) {
      if (
        this.props.driverList?.driverByStockHolder !==
        nextProps.driverList?.driverByStockHolder
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            driverDetail: nextProps.driverList?.driverByStockHolder,
          },
        });
      }
    }
  }

  onSearchData = async (data) => {
    const {
      getStockTransferInOutHeaderByDriver,
      showLoador,
      showNotification,
    } = this.props;
    const { adminFlag } = this.state;
    if (navigator.onLine) {
      if (adminFlag) {
        showLoador({ loador: true });
        await getStockTransferInOutHeaderByDriver({
          driverId: data.driver,
          stockStakeHolderId: data.stockHolder,
          fromDate: data.fromDate,
          toDate: data.toDate,
        }).then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      } else {
        showLoador({ loador: true });
        await getStockTransferInOutHeaderByDriver({
          driverId: data.driver,
          stockStakeHolderId: "",
          fromDate: data.fromDate,
          toDate: data.toDate,
        }).then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      }
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  getListById = async (data) => {
    const {
      getStateByRegion,
      getZoneByState,
      getDistrictByZone,
      getTalukaByDistrict,
      getAreaByTalukaPostBody,
      getStockholderByAreaIdsForFilter,
      getDriversByStockHolderId,
      showLoador,
      showNotification,
    } = this.props;
    const { adminFlag, areaIds } = this.state;
    if (navigator.onLine) {
      if (data.region && data.region != "") {
        showLoador({ loador: true });
        await getStateByRegion({ regionIds: data.region }).then(
          ({ success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          }
        );
      }
      if (data.state && data.state != "") {
        showLoador({ loador: true });
        await getZoneByState({ stateIds: data.state }).then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      }
      if (data.zone && data.zone != "") {
        showLoador({ loador: true });
        await getDistrictByZone({ zoneIds: data.zone }).then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      }
      if (data.district && data.district != "") {
        showLoador({ loador: true });
        await getTalukaByDistrict({ districtIds: data.district }).then(
          ({ success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          }
        );
      }
      if (adminFlag) {
        if (data.taluka && data.taluka != "") {
          let talukaJson = {
            talukaIds: data.taluka,
          };
          showLoador({ loador: true });
          await getAreaByTalukaPostBody({ talukaIds: talukaJson }).then(
            ({ success }) => {
              showLoador({ loador: false });
              if (!success) {
                showNotification({ msg: serverMsg, severity: "error" });
              }
            }
          );
        }

        if (data.area && data.area != "") {
          this.setState({ areaIds: data.area });
          showLoador({ loador: true });
          await getStockholderByAreaIdsForFilter({ areaIds: data.area }).then(
            ({ success }) => {
              showLoador({ loador: false });
              if (!success) {
                showNotification({ msg: serverMsg, severity: "error" });
              }
            }
          );
        }
        if (data.stockHolder && data.stockHolder != "") {
          let areaIdsObj = {
            areaIds: areaIds,
          };

          showLoador({ loador: true });
          await getDriversByStockHolderId({
            stockHolderId: data.stockHolder,
            areaIdJson: areaIdsObj,
          }).then(({ success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          });
        }
      } else {
        if (data.area && data.area != "") {
          let areaIdsObj = {
            areaIds: data.area,
          };

          showLoador({ loador: true });
          await getDriversByStockHolderId({
            stockHolderId: "",
            areaIdJson: areaIdsObj,
          }).then(({ success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          });
        }
      }
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  rowApply = (rowData) => {
    const { showLoador, showNotification } = this.props;
    const { adminFlag } = this.state;
    swal({
      title: "Are you sure?",
      text: approveClaimMsg,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        showLoador({ loador: true });
        const statusCode = 1;
        apiGet({
          url:
            endpoint.stockTransferInOutHeader +
            "/update-status?stockTransferInOutHeaderId=" +
            rowData.id +
            "&status=" +
            statusCode,
        }).then(({ data, success }) => {
          showLoador({ loador: false });
          if (!success) {
            this.props.showNotification({
              msg: serverMsg,
              severity: "error",
            });
          } else {
            showNotification({ msg: statusmsg });
            if (adminFlag) {
              window.location.reload();
            } else {
              this.getOnLoadData();
            }
          }
        });
      }
    });
  };

  rowCancel = (rowData) => {
    const { showLoador, showNotification } = this.props;
    const { adminFlag } = this.state;
    swal({
      title: "Are you sure?",
      text: rejectClaimMsg,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        showLoador({ loador: true });

        const statusCode = 2;

        apiGet({
          url:
            endpoint.stockTransferInOutHeader +
            "/update-status?stockTransferInOutHeaderId=" +
            rowData.id +
            "&status=" +
            statusCode,
        }).then(({ data, success }) => {
          if (!success) {
            showLoador({ loador: false });
            showNotification({
              msg: serverMsg,
              severity: "error",
            });
          } else {
            showNotification({ msg: statusmsg });
            if (adminFlag) {
              window.location.reload();
            } else {
              this.getOnLoadData();
            }
          }
        });
      }
    });
  };

  render() {
    const {
      dayWiseBitAssign,
      setDayWiseBitAssign,
      dayWiseBeatAssignList,
      stockTransferInOutHeaderList,
      getVehicleAssignDayWise,
    } = this.props;
    const { dynamicMasterData, adminFlag, status } = this.state;
    return (
      <>
        <DynamicMainScreen
          dynamicMasterData={dynamicMasterData}
          onSearchData={this.onSearchData}
          getListById={this.getListById}
          searchList={
            adminFlag
              ? StockTransferJson.searchListForAdmin
              : StockTransferJson.searchListForStockHolder
          }
          formPath={StockTransferJson.formPath}
          screenTitle={StockTransferJson.screenTitle}
          fieldMeta={StockTransferJson.fieldMeta}
          showPdfDownload={false}
          showExcelDownload={false}
          changeExcelURL={StockTransferJson.excelUrl}
          showExtension={false}
          filterDataExcel={true}
          pdfFileName={StockTransferJson.pdfFileName}
          excelFileName={StockTransferJson.excelFileName}
          showAddButton={StockTransferJson.showAddButton}
          tableColumnsToFilter={StockTransferJson.tableColumnsToFilter}
          tableColumns={StockTransferColumns}
          tableData={stockTransferInOutHeaderList?.stockTransfer}
          getTableData={this.getOnLoadData}
          apiBaseURL={StockTransferJson.apiBaseURL}
          baseIdColumn={StockTransferJson.baseIdColumn}
          isNote={true}
          isNoteValue={"Stock Transfer"}
          showDeleteIcon={adminFlag ? false : true}
          showEditIcon={true}
          showApply={adminFlag ? false : true}
          showApplyTitle={"Approve"}
          rowApply={this.rowApply}
          callApi={false}
          showCancel={adminFlag ? false : true}
          rowCancel={this.rowCancel}
          showCancelTitle="Reject"
          cancelBillConditionName="approvedStatus"
          cancelBillConditionValue="1"
          credentialConditionName="approvedStatus"
          credentialConditionValue="1"
          deleteConditionName="isShowEditDeleteFlag"
          deleteConditionValue="1"
          editConditionName="isShowEditDeleteFlag"
          editConditionValue="1"
          showViewButtonInTable={true}
          formPathView={StockTransferJson.formPathView}
        />
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  dayWiseBitAssign: state.dayWiseBitAssign,
  areaList: state.area,
  regionList: state.region,
  stateList: state.states,
  zoneList: state.zone,
  districtList: state.district,
  talukaList: state.taluka,
  dayWiseBeatAssignList: state.vehicleAssign,
  stockTransferInOutHeaderList: state.stockTransfer,
  stockHolderList: state.stackholder,
  driverList: state.salesExecutive,
});
const mapDispatchToProps = {
  getRegionNew,
  getZoneByState,
  getDistrictByZone,
  getTalukaByDistrict,
  getAreaByTalukaPostBody,
  getStateByRegion,
  getAreaByUserType,
  showLoador,
  showNotification,
  setDayWiseBitAssign,
  getVehicleAssignDayWise,
  getUpdatedDayWiseBeatOutletCountFromAreas,
  getStockTransferInOutHeader,
  getStockholderByAreaIdsForFilter,
  getDriversByStockHolderId,
  getStockTransferInOutHeaderByDriver,
};
export default connect(mapStateToProps, mapDispatchToProps)(StockTransferTable);
